import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import BasicFAQ from "../components/ui/BasicFAQ";
import Modal from "../components/ui/Modal";
import axios from 'axios';

const ShiftingContactForm = () => {
  const [selected, setSelected] = useState("individual");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    companyName: "",
  });
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  
  const handleSubmit = async (e) => {
    e.preventDefault();
    // Logique pour envoyer les données du formulaire à un serveur
  
    // Envoyer l'email via l'API backend
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/email`, {
        to: "contact@isiliving.fr",
        from: "iannis.taioglou@gmail.com",
        subject: 'New Contact Form Submission',
        text: `Name: ${formData.name}\nEmail: ${formData.email}\nMessage: ${formData.message}\nCompany: ${formData.companyName}`,
        html: `<p>Name: ${formData.name}</p><p>Email: ${formData.email}</p><p>Message: ${formData.message}</p><p>Company: ${formData.companyName}</p>`,
      });
      setIsModalOpen(true);
    } catch (error) {
      console.error('Error sending email:', error);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="bg-cream min-h-screen flex flex-col items-center justify-center py-16 px-4 sm:px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="max-w-3xl w-full text-center"
      >
        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-light leading-4 font-cormorant mb-8 sm:mb-10 md:mb-12 lg:mb-14 text-[#333333]">
          Contactez-nous
        </h1>
        <p className="text-lg sm:text-xl text-gray-700 mb-8">
          Nous serions ravis de vous entendre. Remplissez le formulaire ci-dessous et nous vous répondrons dès que possible.
        </p>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="w-full max-w-6xl mx-auto shadow-lg flex flex-col-reverse lg:flex-row rounded-lg overflow-hidden"
      >
        <Form selected={selected} setSelected={setSelected} formData={formData} handleChange={handleChange} handleSubmit={handleSubmit} />
        <Images selected={selected} />
      </motion.div>
      <Modal isOpen={isModalOpen} onClose={closeModal}>
        <h2 className="text-2xl font-semibold mb-4">Merci pour votre message !</h2>
        <p>Nous vous répondrons dès que possible.</p>
        <button
          onClick={closeModal}
          className="mt-4 bg-brandy-rose text-white py-2 px-4 rounded"
        >
          Fermer
        </button>
      </Modal>
    </div>
  );
};

const Form = ({ selected, setSelected, formData, handleChange, handleSubmit }) => {
  return (
    <form
     onSubmit={handleSubmit}
      className={`p-8 w-full text-white transition-colors duration-[750ms] ${
        selected === "company" ? "bg-dark-gray" : "bg-dark-gray"
      }`}
    >

      {/* Name input */}
      <div className="mb-6">
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Votre nom..."
          className={`${
            selected === "company" ? "bg-peach-cream" : "bg-peach-cream"
          } transition-colors duration-[750ms] placeholder-dark-gray p-2 rounded-md w-full focus:outline-0`}
        />
      </div>

      {/* Email input */}
      <div className="mb-6">
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="Votre email..."
          className={`${
            selected === "company" ? "bg-peach-cream" : "bg-peach-cream"
          } transition-colors duration-[750ms] placeholder-dark-gray p-2 rounded-md w-full focus:outline-0`}
        />
      </div>

      {/* Company/individual toggle */}
      <div className="mb-6">
        <FormSelect selected={selected} setSelected={setSelected} />
      </div>

      {/* Company name */}
      <AnimatePresence>
        {selected === "company" && (
          <motion.div
            initial={{
              marginTop: -104,
              opacity: 0,
            }}
            animate={{
              marginTop: 0,
              opacity: 1,
            }}
            exit={{
              marginTop: -104,
              opacity: 0,
            }}
            transition={BASE_TRANSITION}
            className="mb-6"
          >
            <input
              type="text"
              name="companyName"
              value={formData.companyName}
              onChange={handleChange}
              placeholder="Nom de votre entreprise..."
              className={`${
                selected === "company" ? "bg-peach-cream" : "bg-peach-cream"
              } transition-colors duration-[750ms] placeholder-dark-gray p-2 rounded-md w-full focus:outline-0`}
            />
          </motion.div>
        )}
      </AnimatePresence>

      {/* Info */}
      <div className="mb-6">
        <textarea
          name="message"
          value={formData.message}
          onChange={handleChange}
          placeholder="Ce que vous voulez savoir :)"
          className={`${
            selected === "company" ? "bg-peach-cream" : "bg-peach-cream"
          } transition-colors duration-[750ms] min-h-[150px] resize-none placeholder-dark-gray p-2 rounded-md w-full focus:outline-0`}
        />
      </div>

      {/* Submit */}
      <motion.button
        whileHover={{
          scale: 1.01,
        }}
        whileTap={{
          scale: 0.99,
        }}
        type="submit"
        className={`${
          selected === "company"
            ? "bg-white text-dark-gray"
            : "bg-white text-dark-gray"
        } transition-colors duration-[750ms] text-lg text-center rounded-lg w-full py-3 font-semibold`}
      >
        Envoyer
      </motion.button>
    </form>
  );
};

const FormSelect = ({ selected, setSelected }) => {
  return (
    <div className="border-[1px] rounded border-white overflow-hidden font-medium w-fit">
      <button
        type="button"
        className={`${
          selected === "individual" ? "text-dark-gray" : "text-white"
        } text-sm px-3 py-1.5 transition-colors duration-[750ms] relative`}
        onClick={() => setSelected("individual")}
      >
        <span className="relative z-10">Un particulier</span>
        {selected === "individual" && (
          <motion.div
            transition={BASE_TRANSITION}
            layoutId="form-tab"
            className="absolute inset-0 bg-white z-0"
          />
        )}
      </button>
      <button
        type="button"
        className={`${
          selected === "company" ? "text-dark-gray" : "text-white"
        } text-sm px-3 py-1.5 transition-colors duration-[750ms] relative`}
        onClick={() => setSelected("company")}
      >
        <span className="relative z-10">Une entreprise</span>
        {selected === "company" && (
          <motion.div
            transition={BASE_TRANSITION}
            layoutId="form-tab"
            className="absolute inset-0 bg-white z-0"
          />
        )}
      </button>
    </div>
  );
};

const Images = ({ selected }) => {
  return (
    <div className="bg-white relative overflow-hidden w-full min-h-[100px]">
      <motion.div
        initial={false}
        animate={{
          x: selected === "individual" ? "0%" : "100%",
        }}
        transition={BASE_TRANSITION}
        className="absolute inset-0 bg-slate-200"
        style={{
          backgroundImage:
          "url(https://images.pexels.com/photos/6044265/pexels-photo-6044265.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <motion.div
        initial={false}
        animate={{
          x: selected === "company" ? "0%" : "-100%",
        }}
        transition={BASE_TRANSITION}
        className="absolute inset-0 bg-slate-200"
        style={{
          backgroundImage:
            "url(https://images.pexels.com/photos/12662878/pexels-photo-12662878.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
    </div>
  );
};

export default ShiftingContactForm;

const BASE_TRANSITION = { ease: "anticipate", duration: 0.75 };